import { findWalletBookWallet } from './findWalletBookWallet.js';
import { renderTemplate } from './renderTemplate.js';

const getWalletLinks = (walletBook, walletName) => {
    const walletData = findWalletBookWallet(walletBook, walletName);
    const links = {
        android: '',
        brave: '',
        chrome: '',
        edge: '',
        firefox: '',
        ios: '',
    };
    links.brave =
        renderTemplate('chromeUrl', walletData?.desktop?.chromeId) ?? '';
    links.chrome =
        renderTemplate('chromeUrl', walletData?.desktop?.chromeId) ?? '';
    links.edge = renderTemplate('edgeUrl', walletData?.desktop?.edgeId) ?? '';
    links.firefox =
        renderTemplate('firefoxUrl', walletData?.desktop?.firefoxId) ?? '';
    links.ios =
        renderTemplate('iosUrl', walletData?.mobile?.iosId) ??
            walletData?.mobile?.ios ??
            '';
    links.android =
        renderTemplate('androidUrl', walletData?.mobile?.androidId) ??
            walletData?.mobile?.android ??
            '';
    return links;
};

export { getWalletLinks };
